module.exports = __webpack_public_path__ + "static/media/5DPO7.c2f26df9.jpg";